import { render } from "./ProviderInfo.vue?vue&type=template&id=32a9dbc6"
import script from "./ProviderInfo.vue?vue&type=script&lang=js"
export * from "./ProviderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__